import React from 'react';

const FilledCornerSVG: React.FC = () => (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C13 1 13 6.5 13 13H0C0 12.5 0.646107 10.1387 3 7C5.35389 3.86135 10.5 0.5 16 0Z" fill="#1359C8" />
    </svg>
);

export default FilledCornerSVG;
